import Container, { type ContainerProps } from './container';

export type { ContainerProps };
export default Container;
